export class AppSettings {
	
	// public static IPCL_API = 'http://192.168.1.70:8081/api/v1'; // Developement
	// public static IPCL_API = 'http://192.168.1.61:8081/api/v1'; // Developement
	// public static IPCL_API = 'http://121.242.219.172:8080/icpl_api-v1/api/v1'; // Staging
	// public static IPCL_API = 'https://uat.indiapower.com:443/icpl_api-v1/api/v1'; // Staging
	public static IPCL_API = 'https://mycare.indiapower.com:8443/icpl_api-v1/api/v1'; //PROD

	// public static IPCL_API ='http://192.168.1.55:8080/icpl_api-v1/api/v1';

	public static SEC_KEY_ID_1 = '14587jfaeryn%$#7542Hfra45';
	public static SEC_KEY_ID_2 = '!@#12458/nhs&^%sunh0098%$#';
	public static OXIUSER = 'IPCL';
	public static OXIPASS = 'znfbPLR261E=';
	public static BILLDESK_MARCH = 'INDIAPOWER';
	public static BILLDESK_SEC = 'indiapower';
	public static BILLDESK_URL = 'https://pgi.billdesk.com/pgidsk/PGIMerchantPayment';
	public static PAYTM_URL = 'https://paytm.com/electricity-bill-payment/west-bengal/india-power-corporation-ltd-asansol/prepaid-meter-recharge';
	public static OXIGEN_URL = 'http://122.15.12.37:8119/oxigenapi/api';
	public static SEND_OXI_OTP = '/sendotp';
	public static SEND_EMAIL_OTP = '/otpMatch';
	public static TRANSCTN_OTP_DATA = '/consumerLogin';
	public static GETPERSONALDETAILSBYCONSUMERNO = '/getPersonalInformationByConsumerNo';
	public static CREATEUSER = '/addConsumer';
	public static AUTHUSER = '/authenticateByUserName';
	public static GETPAYABLE = '/getPayableAmountByConsumerNo';
	public static GETBILLGAYA = '/getFullBillForGaya';
	public static GETBILLASANSOL = '/getFullBillForAsansol';
	public static GETBILLHISTORYGAYA = '/getBillingHistoryForGaya';
	public static GETBILLHISTORYASAN = '/getBillingHistoryForAsansol';
	public static OTPSEND = '/sendOTP';
	public static GENERATEPDF = '/generateInvoiceDetailsInPdf';
	public static OTPVALIDATE = '/validateOTP';
	public static GETRESENTMOBILEOTP = '/reCreateMobileOtp';
	public static GETRESENTEMAILOTP = '/reCreateEmailOtp';
	public static GETLOADDETAILS = '/getAllApplienceLoad';
	public static PAYEMD = '/initiateBilldeskPayment';
	public static GETCOMPLAINTITLE = '/getAllGrievanceTitleDetails';
	public static GETCHECKSUM = '/getChecksumKey';
	public static GETADMINCHECKSUM = '/getAdminChecksumKey';
	public static GETCONSUMPTIONHISTORY = '/getConsumptionHistory';
	public static POSTLOGINDETAILS = '/loginByConsumerNumberWithoutOtp';
	//public static GETPAYMENTHISTORY				= '/getConsumptionHistory';
	public static GETCOMPLAINDETAILS = '/api/v1/loginByConsumerNumberWithoutOtp';
	public static POSTGAYAPAYMENT = '/postPaybleAmoutForGaya';
	public static POSTNSC = '/addNewConsumer';
	public static POSTCONSUMERDETAILS = '/addUpdateConsumerInfo';
	public static POSTNSCREG = '/updateConsumerEmailAndPassword';
	public static VALIDATEEMAIL = '/validateEmailAddress';
	public static POSTLOADDETAILS = '/addConsumerApplienceLoadDetails';
	public static VALIDATECONSUMERNO = '/sendOTPtoMobileAndEmail';
	public static VALIDATECONSUMERNOWITHOTP = '/loginByConsumerNumber';
	public static GETBLROLIST = '/getAllBlroMaster';
	public static GETPREFIXLIST = '/getConsumerPrefix';
	public static GETOTPBYEMAIL = '/getEmailOtp';
	public static VALIDATEBYEMAILOTP = '/loginByEmailId';
	public static GETOTPBYMOBILE = '/getMobileOtp';
	public static VALIDATEBYMOBILEOTP = '/loginByMobileNo';
	public static VALIDATECONSUMERWITHPASS = '/loginByConsumerNumber';
	public static GETDOCUMETTYPEBYID = '/getProofOfIdentityDocumentsDetails';
	public static GETDOCUMETTYPEBYOWN = '/getProofOfOwnershipDocumentsDetails';
	public static GETDOCUMETTYPEBYAUTH = '/getAuthorizationDocumentsDetails';
	public static GETMAUZALIST = '/getAllMouzaMasterByBlro';
	public static IDENTIFICATNUPLOAD = '/uploadIdentificationDoc';
	public static OWENERSHIPUPLOAD = '/uploadOwnershipDoc';
	public static AUTHRISONUPLOAD = '/uploadAuthorizationDoc';
	public static GETFILEDETAILS = '/downloadQuatationDocuments';
	public static DOWNLOADORVIEWINVOICEPDF = '/downloadOrViewInvoicePdf';
	public static DOWNLOADORVIEWINVOICEBILLPDF = '/billPdfdownloadDocuments';
	public static GETPURPOSESUPPLYLIST = '/getAllSupplyPurposeMaster';
	public static GETPOWERSUPPLYTYPELIST = '/getAllPowerSupplyMaster';
	public static GETCONNECTIONTYPELIST = '/getAllConnectionTypeMaster';
	public static GETCATAGORYTYPELIST = '/getAllCategoryTypeMaster';
	public static GETAPPLIEDPHASELIST = '/getAllPhaseAppliedMaster';
	public static GETCONSUMERLIST = '/getConsumerInfo';
	public static GETEMDVALUE = '/getEmdDetailsByTransactionNumber';
	public static GETMILDETAILS = '/sendNotificationToConsumer';
	public static GENERATEBILLPDF = '/billHistoryInvoiceDetailsGenerate';
	public static GETKYC = '/getKYCInfo';
	public static ADDKYC = '/addConsumerKyc';
	public static FORGOTPASS = '/forgot-password';
	public static FORGOTPASSFORNSC = '/getPasswordByEmailId';
	public static GETADTOSHOW = '/getAllActiveAdvertisingDetails';
	public static ADDADDETAILS = '/addAdvertisingViewDetails';
	public static GETZONALBROAD = '/getBroadcastMessage';
	public static GETHTGAYABILL = '/getBillParamsFormHT';
	public static PAYMENTNSCSEND = '/getTransactionList';
	public static TRANSACTIONNSCSEND = '/getConsumerDetailsByTransactionId';
	public static GETTRANSACTIONID = '/updateDocumentUpload';
	public static GETGREVIENCESUBCAT = '/getAllGrievanceMaster';
	public static GETCATAGORYLIST = '/getAllGrievanceTypeDetails';
	public static GETSUBCATAGORYLIST = '/getAllGrievanceSubTypeDetails';
	public static POSTGRIEVANCE = '/saveGrievanceDetails';
	public static GETUSERDETAILS = '/src/app/config/mock/userdetails.json';
	public static GETLOCATION = '/src/app/config/mock/region.json';
	public static GETALLGREVIENCE = '/getAllGrievanceDetail';
	public static GETALLREQUEST = '/src/app/config/mock/request.json';
	public static GETGREVIENCECAT = '/src/app/config/mock/greviencecategory.json';
	public static GETREQUESTCAT = '/src/app/config/mock/requestcategory.json';
	public static GETBILLDETAILS = '/src/app/config/mock/quickPay.json';
	public static BLROLIST = 'app/config/mock/blro.json';
	public static AUTHENTICATECOMPLAINCONSUMERNOANDMOBILE = '/authenticateComplainConsumerNoAndMobile';

	//LoginMasterController//
	//---------------------//
	public static NEWAUTHUSER = '/authenticateByConsumerIdPassword';
	public static GETCONSUMERINFOBYCONSUMERID = '/getConsumerInfoByConsumerId';

	//BroadCastMessageMasterController//
	//--------------------------------//
	public static GETGENERALBROAD = '/getGeneralBroadcastMessage';
	public static GETBLROREGIONBROADCASTDATA = '/getBlroRegionNameWiseBroadcastData';
	public static GETBLROREGIONIDWISEBROADCASTDATA = '/getBlroRegionWiseBroadcastData';
	public static GETMOUZAZONEBROADCASTDATA = '/getMouzaZoneWiseBroadcastData';
	public static GETBLROREGIONMOUZAZONEIDWISEBROADCASTDATA = '/getBlroRegionWiseZoneBroadcastData';
	//BlroRegionMasterController//
	//--------------------------//
	public static GETALLBLROREGION = '/getAllBlroRegion';
	//MouzaZoneMasterController//
	//-------------------------//
	public static GETZONEDATA = '/getZoneByBlroRegionId';
	public static GETPAYMENTDETAILSBYCONSUMERID = '/getPaymentDetailsByConsumerId';
	public static FILTERPAYMENTDETAILSByCONSUMERID = '/filterPaymentDetailsByConsumerId';
	public static SAVEFEEDBACK = '/saveFeedback';
	public static SAVERAZORPAYRESPONSE = '/processRazorpayPaymentResponse';
	public static GETCONNECTIONMANAGEMENTHISTORY = '/getConnectionManagementHistory';
	public static SAVECONNECTIONMANAGEMENTDETAILS = '/saveConnectionManagementDetails';
	public static GETTARIFFDETAILS = '/getAllTarrifCatagoryMaster';
	public static GETFIRSTQUESTION = '/getFirstQuestion';
	public static GETUNIQUEANS = '/getUniqueAns';
	public static GETANSWER = '/getAnswer';
	public static GETNEXTQUESTION = '/getNextQuestion'
	public static GETUSERQUERY = '/getUserQuery'

	public static RESETPASSWORD = '/reset-password';
	public static SOLARINFO = '/solarinformation';
	public static SOLARGUIDE = '/downloadsolarpvinstruction';
	public static SOLARPVFORM = '/downloadsolarpvform';
	public static GETPREPAIDMETERDETAIL = '/get-prepaid-meter-detail';
	public static CHECKMETER = '';
	public static PREPAIDPAYMENT = '/prepaid-payment-initiate';
	// public static TRANSACTIONSTATUS = '/transactionStatus';
	// public static BALANCEENQUIRY = '/balanceQueryDetails';
	public static BALANCEENQUIRY = '/unit-balance';
	public static BALANCEENQUIRYREVISED = '/unit-balance-revised';
	public static SAPRECHARGE = 'recharge';
	public static SAPTRANSACTIONSTATUS = 'transaction_status';
	public static SAPBALANCEENQUIRY = 'balance';
	public static TRANSACTIONSTATUS = '/txn-status';
	public static SAVEPREPAIDRAZORPAYRESPONSE = '/prepaid-razorpaymentreceiver';
	// public static SAPBALANCEENQUIRY = '/app/config/mock/SAPBALANCEENQUIRY.json';	
	public static PREPAIDPAYMENTCONSHISTORIES = '/prepaid-payment-cons-histories';
	public static GETPREPAIDCONSUMPTIONHISTORIES = '/get-prepaid-consumption-histories';
	public static PROCESSSTATUSBYOLDCAPITAL = '/processStatusByOldCapital';
	
}




// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/config/settings/app-settings.ts